//@ts-ignore
// import { CONTENT_ACCESS_TABS } from 'admin_header/App';
import { APPLICATIONS } from '../../ApplicationUrls';

const NONE = 'NONE';

/* [ToDo] need to bring from admin-header */

export const CONTENT_ACCESS_TABS = {
  CONTENT: 'content',
  LEARNERS: 'learner',
  ANALYTICS: 'analytics',
  REVIEWS: 'review',
  REINFORCEMENT: 'reinforcement',
  ASSET: 'asset',
  CALLAI: 'callai',
  MARKETPLACE: 'marketplace',
  DIGITAL_SALES_ROOMS: 'digital_sales_rooms',
};

export const ACTIVE_TAB_MAPPING = {
  [CONTENT_ACCESS_TABS.CONTENT]: [],
  [CONTENT_ACCESS_TABS.LEARNERS]: [
    APPLICATIONS.LEARNERS_URL,
    APPLICATIONS.PROFILE_MANAGEMENT,
    APPLICATIONS.USER_DETAILS,
    APPLICATIONS.GROUP_DETAILS,
  ],
  [CONTENT_ACCESS_TABS.ANALYTICS]: [APPLICATIONS.ANALYTICS],
  [CONTENT_ACCESS_TABS.REVIEWS]: [APPLICATIONS.REVIEWS],
  [CONTENT_ACCESS_TABS.REINFORCEMENT]: [APPLICATIONS.REINFORCEMENT],
  [CONTENT_ACCESS_TABS.ASSET]: [APPLICATIONS.ASSET],
  [CONTENT_ACCESS_TABS.CALLAI]: [APPLICATIONS.CALLAI_ADMIN],
  [CONTENT_ACCESS_TABS.MARKETPLACE]: [APPLICATIONS.PROGRAM_TEMPLATES],
  [CONTENT_ACCESS_TABS.DIGITAL_SALES_ROOMS]: [APPLICATIONS.DSR],
  [NONE]: [
    APPLICATIONS.CONTENT_CENTER,
    APPLICATIONS.TESTING,
    APPLICATIONS.EDIT_READINESS_DASHBOARD,
    APPLICATIONS.EMAIL_LOGS,
    APPLICATIONS.AUTOMATION_SUITE,
    APPLICATIONS.AUTOMATION_RULES,
    APPLICATIONS.ADMIN_PAGES,
    APPLICATIONS.ADAPTIVE_PAGES,
    APPLICATIONS.AUDIT_LOGS,
    APPLICATIONS.ACCOUNT_SETTINGS_INTEGRATIONS,
    APPLICATIONS.ACCOUNT_SETTINGS_NEW,
  ],
};

const SITE_INFO_STYLES = { height: '22px', width: '80px', marginRight: '16px' };
const CENTER_TAB_STYLES = { height: '20px', width: '80px', margin: '6px 16px' };
const THUMBNAIL_STYLES = { height: '24px', width: '24px', borderRadius: '50%' };
const SEARCH_BAR_STYLES = { height: '20px', width: '20px', marginRight: '24px' };
const SITE_THUMBNAIL_STYLES = {
  height: '32px',
  width: '32px',
  marginRight: '12px',
  borderRadius: '4px',
};
const SMALL_SETTINGS_STYLES = {
  height: '20px',
  width: '20px',
  marginRight: '24px',
  borderRadius: '50%',
};

export const LOADER_STYLES = {
  THUMBNAIL_STYLES,
  SITE_INFO_STYLES,
  CENTER_TAB_STYLES,
  SEARCH_BAR_STYLES,
  SITE_THUMBNAIL_STYLES,
  SMALL_SETTINGS_STYLES,
};
